import { Buffer } from 'buffer';

export const SESSION_KEY = 'encryptToken';

/**
 * Call once after login with the primary card details.
 * Saves the token to sessionStorage so it survives page refreshes.
 */
export function initToken(cnic, custId, cardNumber) {
	const key = `${cnic}|${custId}|${cardNumber}`;
	const encoded = Buffer.from(key, 'utf-8').toString('base64');
	const randomSuffix = getRandomCharacters(3);
	const encryptData = encoded + randomSuffix;
	// console.log("Token initialised, random suffix:", randomSuffix);
	sessionStorage.setItem(SESSION_KEY, encryptData);







	
}

/**
 * Returns the single session token generated at login.
 * Reads from sessionStorage — same value every call until logout.
 */
export function getEncodedHeaderObject() {
	const encryptData = sessionStorage.getItem(SESSION_KEY);
	if (encryptData) {
		return { encryptData };
	}
	// Fallback: generate from localStorage values if initToken was never called (e.g. dev reload)
	const cnic = localStorage.getItem('cnic');
	const custId = localStorage.getItem('custId');
	const cardNumber = localStorage.getItem('cardNumber');
	initToken(cnic, custId, cardNumber);
	return { encryptData: sessionStorage.getItem(SESSION_KEY) };
}

export function clearTokenCache() {
	sessionStorage.removeItem(SESSION_KEY);
}

function getRandomCharacters(length) {
	const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let result = '';

	for (let i = 0; i < length; i++) {
		const randomIndex = Math.floor(Math.random() * chars.length);
		result += chars[randomIndex];
	}

	return result;
}

